import AddIcon from '@mui/icons-material/Add';

const CustomAddIcon = ({ size }) => {
  return (
    <AddIcon
      sx={{
        width: size,
        height: size,
      }}
    />
  );
};

export default CustomAddIcon;
